export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $sliderItems = document.querySelectorAll('.glide.teaserslider__slider-glide-images');

        if (!$sliderItems.length) {
            return;
        }

        $sliderItems.forEach((slider) => {
            const $slides = slider.querySelectorAll('#' + slider.id + ' .glide__slide');

            // only initialize a slider when we have more than one slide
            if ($slides.length > 1) {
                // responsive/breakpoints settings
                const gapItem = 24;
                const slidesPerView = $slides.length;
                let slidesPerViewDesktop = slidesPerView;
                let slidesPerViewMobile = slidesPerView;
                if (slidesPerView >= 3) {
                    slidesPerViewDesktop = 3;
                }
                if (slidesPerView >= 2) {
                    slidesPerViewMobile = 2;
                }

                /*
                  carousel:
                  - type: 'carousel',
                  - autoplay: interval,

                  slider:
                  - type: 'slider',
                  - rewind: false,
                  - autoplay: 0,
                */
                const $teaserslider = new Glide('#' + slider.id, {
                    type: 'carousel',
                    autoplay: slider.dataset.interval || 5000,
                    animationDuration: 1000,
                    gap: gapItem,
                    perView: slidesPerViewDesktop,
                    breakpoints: {
                        992: {
                            perView: slidesPerViewMobile,
                        },
                        640: {
                            perView: 1,
                        },
                    },
                });

                let indexStart = 0;
                let indexEnd = 0;

                // SEO image loading 1/2
                $slides[0].classList.add('glide__slide-img-visible');

                $teaserslider.mount();

                // SEO image loading 2/2
                $teaserslider.on(['run.before'], () => {
                    indexStart = $teaserslider.index;
                });

                $teaserslider.on(['run', 'move'], () => {
                    $slides[$teaserslider.index].classList.add('glide__slide-img-visible');
                    indexEnd = $teaserslider.index;
                    // if there is a pagination click...
                    const indexRange = indexEnd - indexStart;
                    if (indexRange > 1) {
                        for (let i = indexStart; i <= indexEnd; ++i) {
                            $slides[i].classList.add('glide__slide-img-visible');
                        }
                    }
                });
            } else {
                // show image
                document.getElementById(slider.id).classList.add('glide__slide-all-img-visible');
            }
        });
    });
}
